export enum EmployeesResources {
    AssignReminders = '/v2/companyManagement/companies/:company/onboarding/assignReminders',
    AssignOffboardingReminders = '/v2/companyManagement/companies/:company/offboarding/assignReminders',
}
